"use client";

import { PhotoPanel } from "./photo-panel";
import { ExposureCard } from "./exposure-card";
import { WhiteBalanceCard } from "./white-balance-card";
import { FocusCard } from "./focus-card";

/**
 * Service control panel for one camera: live photo with ROI focusing on the
 * left, exposure / white balance / focus / stream settings on the right.
 * Works for assigned and unassigned cameras alike (all calls go through the
 * backend's ThingsBoard RPC endpoints).
 */
export const CameraControl = ({ deviceId }: { deviceId: string }) => {
  return (
    <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
      <div className="xl:col-span-2">
        <PhotoPanel deviceId={deviceId} />
      </div>
      <div className="flex flex-col gap-4">
        <ExposureCard deviceId={deviceId} />
        <WhiteBalanceCard deviceId={deviceId} />
        <FocusCard deviceId={deviceId} />
        {/* StreamCard (./stream-card) is parked for now - re-add here once
            the ingest/view server is ready for admin use */}
      </div>
    </div>
  );
};
